import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/MindboxPageView.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/scriptMindbox.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/lib/FeatureProductCatalogBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/util/parseAsObject.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/logos/bioderma.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/logos/esthederm.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/category/button/base/src/lib/UiCategoryButtonBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/banner/gift-card/src/lib/UiKitBannerGiftCard.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/banner/hero/src/lib/UiKitBannerHero.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/carousel/base/src/lib/UiKitCarouselBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/section/seo-text/src/lib/UiKitSectionSeoText.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/mod/footnote/base/src/lib/UiModFootnoteBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/product/layout/catalog/src/lib/UiProductLayoutCatalog.tsx");
